export default __webpack_public_path__ + "static/public-cards-fa935e5fef1189b88f07798f36894ded.png";